import React, { useRef } from 'react'

import { array } from 'prop-types'

import DesignerModel from 'Pods/Shared/PrintModels/components/DesignerModel'

function ModelScrollList({ models }) {
  const scrollContainerRef = useRef(null)

  if (models.length === 0) {
    return null
  }

  return (
    <div className="model-scroll-list">
      <div className="model-scroll-list__container" ref={scrollContainerRef}>
        {models.map((model) => (
          <div key={model.id} className="model-scroll-list__item">
            <DesignerModel {...model} lazyLoad />
          </div>
        ))}
      </div>
    </div>
  )
}

ModelScrollList.propTypes = {
  models: array.isRequired,
}

export default ModelScrollList
